import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getReportList, ReportFilterParams} from '../../services/ReportService'

interface ReportState {
  ReportList: any
}

const initialState: ReportState = {
  ReportList: null,
}

export const getReportListApi = createAsyncThunk(
  'report/getReportList',
  async (params: ReportFilterParams, {rejectWithValue}) => {
    try {
      const result = await getReportList(params)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const ReportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReportListApi.fulfilled, (state, action) => {
      state.ReportList = action.payload
    })
  },
})

export default ReportSlice
